import { z } from 'zod/v4';
import {
  exerciseTypeEnum,
  baseExerciseSchema,
  multipleChoiceExerciseSchema,
  writtenExerciseSchema,
  recordedExerciseSchema,
  fillInBlankExerciseSchema,
  selectForBlankExerciseSchema,
  conversationalExerciseSchema,
  matchingExerciseSchema,
  scrambleExerciseSchema,
  fileUploadExerciseSchema,
  exerciseSchema,
  createNewExerciseFromSchema
} from '../schemas/exercise';

// Exercise type enum - includes both base types and subtypes
export enum ExerciseType {
  MultipleChoice = "MultipleChoice",
  Written = "Written",
  Recorded = "Recorded",
  FillInBlank = "FillInBlank",
  SelectForBlank = "SelectForBlank",
  Conversational = "Conversational",
  Matching = "Matching",
  Scramble = "Scramble",
  FileUpload = "FileUpload",
  LongAnswer = "LongAnswer",
  ShortAnswer = "ShortAnswer"
}

export const subtypeToTypeMap: Record<string, string> = {
  MultipleChoice: "MultipleChoice",
  LongAnswer: "Written",
  ShortAnswer: "Written",
  Recorded: "Recorded",
  FillInBlank: "FillInBlank",
  SelectForBlank: "SelectForBlank",
  Conversational: "Conversational",
  Matching: "Matching",
  Scramble: "Scramble",
  FileUpload: "FileUpload"
};

// Export type definitions inferred from the schemas
// Named with "Type" suffix to avoid conflicts with Drizzle table names
export type BaseExerciseType = z.infer<typeof baseExerciseSchema>;
export type MultipleChoiceExerciseType = z.infer<typeof multipleChoiceExerciseSchema>;
export type WrittenExerciseType = z.infer<typeof writtenExerciseSchema>;
export type RecordedExerciseType = z.infer<typeof recordedExerciseSchema>;
export type FillInBlankExerciseType = z.infer<typeof fillInBlankExerciseSchema>;
export type SelectForBlankExerciseType = z.infer<typeof selectForBlankExerciseSchema>;
export type ConversationalExerciseType = z.infer<typeof conversationalExerciseSchema>;
export type MatchingExerciseType = z.infer<typeof matchingExerciseSchema>;
export type ScrambleExerciseType = z.infer<typeof scrambleExerciseSchema>;
export type FileUploadExerciseType = z.infer<typeof fileUploadExerciseSchema>;
export type ExerciseData = z.infer<typeof exerciseSchema>;

// Re-export the create function with the enum type for backward compatibility
export const createNewExercise = (type: ExerciseType, order: number = 0): ExerciseData => {
  return createNewExerciseFromSchema(type as z.infer<typeof exerciseTypeEnum>, order);
};
